export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '9e2f2bb5-22df-42fe-af89-e85e809567c8';
export const MODAL_CLOSE_SEC = 2.5;
